import { ERROR_CODES } from '@fkwd-qc/shared';

/**
 * Builds the wording shown when a slug does not follow the shared kebab-case rule.
 *
 * @since 1.3.0
 * @param example - a slug that would be accepted, shown so the rule is concrete
 * @returns the error message
 */
export function slugErrorMessage(example: string): string {
    return `Use lowercase kebab-case, starting with a letter, for example ${example}.`;
}

/**
 * What to do after a failure the app cannot name, with the reference to quote.
 *
 * @since 1.3.0
 */
export const RETRY_ADVICE = `Try again, and quote reference ${ERROR_CODES.internal} if it keeps happening.`;

/**
 * The generic line shown when a request fails for a reason the app cannot name.
 *
 * @since 1.3.0
 */
export const GENERIC_FAILURE_MESSAGE = `That did not go through. ${RETRY_ADVICE}`;
